<div class="grid grid-cols-2 gap-2">
  <button
    type="button"
    class="bg-theme-blue rounded px-2 py-1.5 text-xs font-bold text-white uppercase hover:opacity-90"
    data-testid="dev-tools-fill-all"
    (click)="generate('all')">
    Alle Felder
  </button>

  <button
    type="button"
    class="border-theme-gray-500 text-theme-gray-800 hover:bg-theme-blue-gray rounded border px-2 py-1.5 text-xs font-bold uppercase"
    data-testid="dev-tools-fill-required"
    (click)="generate('required')">
    Nur Pflichtfelder
  </button>
</div>
